import { Component, Input } from "@angular/core"

@Component({
    selector: "app-card-content-project-name",
    templateUrl: "./card-content-project-name.component.html",
    styleUrls: ["./card-content-project-name.component.scss"],
    standalone: false,
})
export class CardContentProjectNameComponent {
    @Input() text: string = ""
}
